import { useEffect, useState } from "react"

export const useScrollWidth = () => {
  const [scrollWidth, setScrollWidth] = useState(0)

  useEffect(() => {
    const el = document.createElement('div')
    el.setAttribute('style', `
      opacity: 0;
      width: 100px;
      position: absolute;
      top: 0;
      left: 0;
      overflow-y: scroll;`)
    el.classList.add('scroll-width')
    document.body.appendChild(el)
    setScrollWidth(100 - el.clientWidth)

  }, [])

  return scrollWidth
}